import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
var CombinedName = /*#__PURE__*/function () {
  function CombinedName(combinedName) {
    if (combinedName) {
      this._auto = combinedName.auto || true;
      this._prefix = combinedName.prefix;
    }
  }

  var _proto = CombinedName.prototype;

  _proto.getCombinedNameObjectification = function getCombinedNameObjectification() {
    return {
      prefix: this._prefix,
      auto: this._auto
    };
  };

  _createClass(CombinedName, [{
    key: 'prefix',
    get: function get() {
      return this._prefix;
    }
  }, {
    key: 'auto',
    get: function get() {
      return this._auto;
    }
  }]);

  return CombinedName;
}();

export { CombinedName as default };